const URL_REGEX = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
const TRAILING_PUNCT = /[.,;:!?)\]]+$/;

export const tokenizeWithLinks = (text) => {
  if (!text || typeof text !== 'string') return [];

  const tokens = [];
  let lastIndex = 0;
  const matches = text.matchAll(URL_REGEX);

  for (const match of matches) {
    const raw = match[0];
    const start = match.index;
    const trailing = raw.match(TRAILING_PUNCT);
    const url = trailing ? raw.slice(0, raw.length - trailing[0].length) : raw;
    const trailingText = trailing ? trailing[0] : '';

    if (start > lastIndex) {
      tokens.push({ type: 'text', value: text.slice(lastIndex, start) });
    }
    const href = url.startsWith('www.') ? `https://${url}` : url;
    tokens.push({ type: 'url', value: url, href });
    if (trailingText) {
      tokens.push({ type: 'text', value: trailingText });
    }
    lastIndex = start + raw.length;
  }

  if (lastIndex < text.length) {
    tokens.push({ type: 'text', value: text.slice(lastIndex) });
  }

  return tokens;
};
